import React from "react";
import "./App.css";
import "semantic-ui-css/semantic.min.css";
import Form from "./Form/Form";
import SuccessPage from "./Form/SuccessPage.js";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import axios from "axios";
import Loader from "react-loader-spinner";
import parse from 'html-react-parser';
import { baseUrl } from "./utils/function.js";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            main_color: "",
            second_color: "",
            id_club: "",
            backgroundLoaded: false,
            vImg: Math.random() * 1000,
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);

        // DEV
        // const url = "demo.tfb.academy";
        // LIVE
        // const url = window.location.hostname;

        const urls = {
            1: "politehnicaiasi.tfb.academy",
            2: "suporter.academiadidi.ro",
            6: "demo.tfb.academy",
        }

        const selected_club = 6;
        const team_name = window.location.host.includes("localhost") ? urls[selected_club] : window.location.hostname;

        axios
            .get(
                baseUrl(`club/declaration_form_color?team_name=${team_name}`)
            )
            .then((res) => {
                this.setState({
                    main_color: res.data.color,
                    second_color: res.data.second_color,
                    id_club: res.data.id_club,
                    declaration_form_description: res.data.declaration_form_description != null ?
                        parse(res.data.declaration_form_description)
                        : "",
                });
            })
            .catch((err) => console.log(err));

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    render() {
        return (
            <Router>
                <ScrollToTop>
                    <div className="App">
                        <div
                            className="background-image-container"
                            style={{ backgroundColor: this.state.main_color }}
                        >
                            <img
                                src={baseUrl(`uploads/tax_redirectors/form_background_image/${this.state.id_club}.png?v=${this.state.vImg}`)}
                                alt="background"
                                style={
                                    this.state.backgroundLoaded
                                        ? {}
                                        : { display: "none" }
                                }
                                className="background-image"
                                onLoad={() =>
                                    this.setState({ backgroundLoaded: true })
                                }
                            />
                        </div>
                        {!this.state.backgroundLoaded ? (
                            <div className="loader-container">
                                <Loader
                                    type="TailSpin"
                                    color={this.state.main_color}
                                    height={80}
                                    width={80}
                                />
                            </div>
                        ) : (
                            <Switch>
                                <Route
                                    exact
                                    path="/"
                                    render={(props) => (
                                        <Form
                                            {...props}
                                            width={this.state.width}
                                            height={this.state.height}
                                            id_club={this.state.id_club}
                                            color={this.state.main_color}
                                            second_color={
                                                this.state.second_color
                                            }
                                            title_color={
                                                this.state.id_club == 1 ||
                                                    this.state.id_club == 4
                                                    ? this.state.main_color
                                                    : this.state.second_color
                                            }
                                            declaration_form_description={this.state.declaration_form_description}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path="/success"
                                    render={(props) => (
                                        <SuccessPage
                                            {...props}
                                            color={
                                                this.state.id_club == 1 ||
                                                    this.state.id_club == 4
                                                    ? this.state.main_color
                                                    : this.state.second_color
                                            }
                                            buttonColor={this.state.main_color}
                                            buttonColorText={
                                                this.state.second_color
                                            }
                                        />
                                    )}
                                />
                            </Switch>
                        )}
                    </div>
                </ScrollToTop>
            </Router>
        );
    }
}

export default App;
